import type FormCC from "@/interface/FormCC";
import type { Ref } from "vue";
import { ref } from "vue";

export default function useFormCC(): Ref<FormCC> {
  return ref<FormCC>({
    activeButton: "customer",
    cifNo: "",
    token: "",
    isDraft: false,
    webFormRequestId: "",
    dropOffStep: 1,
    refNo: "",
    dsrBurst: "",
    cardName: "",
    cardMinSalary: "",
    ctosScore: "",
    imageFilePath: "",
    stepFrom: "",
    basicInformation: {
      title: "",
      name: "",
      idType: "",
      idNo: "",
      oldIc: "",
      militaryNo: "",
      nationality: "",
      dob: "",
      email: "",
      countryCode: "",
      mobileNo: "",
      homeCountryCode: "",
      homePhoneNo: "",
      grossSalary: 0,
      netSalary: 0,
      profession: "",
      others: "",
      question1: "",
      repayment: 0,
      consent: "",
      declaration: [],
      jcklMembershipNo: "",
      jcklClubStatus: "",
    },
    ekyc: {
      webFormRequestId: "",
      status: "",
      //EKYC20240117122048000078
      refId: "",
      url: "",
      action: "",
      preStatus: "",
      fail: false,
      interval: false,
      completedInCC: false,
      refreshBtnDisabled: false,
      backBtnDisabled: false,
    },
    preAss: {
      webFormRequestId: "",
    },
    personalInformation: {
      title: "",
      gender: "",
      race: "",
      otherRace: "",
      residencyStatus: "",
      maritalStatus: "",
      motherMaidenName: "",
      dependency: "",
      academic: "",
      otherAcademic: "",
      residentialAddress1: "",
      residentialAddress2: "",
      residentialAddress3: "",
      postCode: "",
      city: "",
      state: "",
      residentialOwnership: "",
      yearStay: "",
      monthStay: "",
      question1: "",
      permanentAddress1: "",
      permanentAddress2: "",
      permanentAddress3: "",
      postCode2: "",
      city2: "",
      state2: "",
    },
    emergencyContact: {
      title: "",
      relationship: "",
      relativeName: "",
      countryCode: "",
      mobileNo: "",
    },
    employmentDetails: {
      question1: "",
      question2: "",
      occupation: "",
      employment: "",
      employmentIncome: "",
      companyName: "",
      sstRegistrationNo: "",
      companyAddress1: "",
      companyAddress2: "",
      companyAddress3: "",
      postCode: "",
      city: "",
      state: "",
      countryCode: "",
      phoneNo: "",
      areaCode: "",
      lengthEmployment: "",
      natureBusiness: "",
      others: "",
      yearEmp: "",
      monthEmp: "",
    },
    principalDetails: {
      name: "",
      deliveryOption: "",
      branch: "",
      address1: "",
      address2: "",
      address3: "",
      postCode: "",
      city: "",
      state: "",
      eStatement: "",
      billingAddress: "",
      branchValue: "",
      jcklClubBillPeriod: "",
      jcklFeeAmount: "",
    },
    uploadDocument: {
      proofIdentity: {
        file: [],
        fileName: [],
        fileNumber: 0,
        resumeFileNumber: 0,
        resumeDeletedFile: [],
        invalidFile: [],
      },
      proofIncome: {
        file: [],
        fileName: [],
        fileNumber: 0,
        resumeFileNumber: 0,
        resumeDeletedFile: [],
        invalidFile: [],
      },
      additional: {
        file: [],
        fileName: [],
        fileNumber: 0,
        resumeFileNumber: 0,
        resumeDeletedFile: [],
        invalidFile: [],
      },
      proofJCKL: {
        file: [],
        fileName: [],
        fileNumber: 0,
        resumeFileNumber: 0,
        resumeDeletedFile: [],
        invalidFile: [],
      },
      supplementary: "",
    },
    MosUploadDocument: {
      proofIdentity: {
        file: [],
        fileName: [],
        fileNumber: 0,
        resumeFileNumber: 0,
        resumeDeletedFile: [],
        invalidFile: [],
      },
      proofIncome: {
        file: [],
        fileName: [],
        fileNumber: 0,
        resumeFileNumber: 0,
        resumeDeletedFile: [],
        invalidFile: [],
      },
      additional: {
        file: [],
        fileName: [],
        fileNumber: 0,
        resumeFileNumber: 0,
        resumeDeletedFile: [],
        invalidFile: [],
      },
      supplementary: "",
      proofJCKL: {
        file: [],
        fileName: [],
        fileNumber: 0,
        resumeFileNumber: 0,
        resumeDeletedFile: [],
        invalidFile: [],
      },
    },
    EPCCUploadDocument: {
      proofIdentity: {
        file: [],
        fileName: [],
        fileNumber: 0,
        resumeFileNumber: 0,
        resumeDeletedFile: [],
        invalidFile: [],
      },
      proofIncome: {
        file: [],
        fileName: [],
        fileNumber: 0,
        resumeFileNumber: 0,
        resumeDeletedFile: [],
        invalidFile: [],
      },
      additional: {
        file: [],
        fileName: [],
        fileNumber: 0,
        resumeFileNumber: 0,
        resumeDeletedFile: [],
        invalidFile: [],
      },
      supplementary: "",
    },
    supplementary: {
      webFormRequestId: "",
      question1: "",
      title: "",
      fullName: "",
      idType: "",
      idNo: "",
      nameOnCard: "",
      nationality: "",
      dob: "",
      gender: "",
      race: "",
      otherRace: "",
      motherMaidenName: "",
      relationship: "",
      email: "",
      mobileCountryCode: "",
      mobileNo: "",
      residentialAddress1: "",
      residentialAddress2: "",
      residentialAddress3: "",
      postCode: "",
      city: "",
      state: "",
    },
    supplementaryUploadDocument: {
      proofIdentity: {
        file: [],
        fileName: [],
        fileNumber: 0,
        resumeFileNumber: 0,
        resumeDeletedFile: [],
        invalidFile: [],
      },
    },
    declaration: {
      declaration: "",
      declaration2: "",
      declaration3: "",
      declaration4: "",
      declaration5: "",
      taxpayer: "",
    },
    summarySetting: {
      personalInformationJump: false,
      emergencyContactJump: false,
      employmentDetailsJump: false,
      principalCardDetailsJump: false,
      uploadDocumentsJump: false,
      supplementaryCardDetailsJump: false,
      supplementaryUploadFileJump: false,
      additionalInformationJump: false,
    },
    selectedCard: {
      image: [],
      cardName: "",
      cardInfo: [],
      cardId: "",
      selected: true,
      nationality: "",
      minAge: 0,
      minSalary: 0,
    },
  });
}
